import { useEffect, useMemo, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

const FILLS = ["linear-gradient(160deg,#a3242c,#6d0f17 60%,#4a080e)", "linear-gradient(160deg,#1c8a4b,#0b5a2e 60%,#063a1d)",
  "linear-gradient(160deg,#2a63c4,#123b8a 60%,#0a2360)", "linear-gradient(160deg,#6d3bb8,#43208a 60%,#2a0f5c)",
  "linear-gradient(160deg,#c98a2c,#8a4f10 60%,#5a2f06)", "linear-gradient(160deg,#16909b,#0c5e69 60%,#063c44)"];
export const metalFill = (i) => FILLS[i % FILLS.length];

const istToday = () => new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10);
const n = (v) => Number(v) || 0;
const rowDate = (r) => String(r.date_iso || r.iso_date || r.date || "").slice(0, 10);

export function SalesQuickFilter({ period, setPeriod, setSelectedMonth }) {
  const cur = istToday().slice(0, 7);
  const pick = (p) => { setPeriod(p); setSelectedMonth(cur); };
  return (
    <div className="flex flex-wrap gap-2" data-testid="sales-quick-filter">
      {[["today", "Today"], ["week", "This Week"], ["month", "This Month"]].map(([k, l]) => (
        <button key={k} type="button" className="bi-pill" data-active={period === k} onClick={() => pick(k)} data-testid={`sales-quick-${k}`}>{l}</button>))}
    </div>
  );
}

function useAllCentreRows(period, selectedCenter, centers, token, curOf) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (period === "month" || (selectedCenter && selectedCenter !== "all") || !centers?.length) { setRows(null); return; }
    let live = true;
    const month = istToday().slice(0, 7);
    Promise.all(centers.map((c) => fetch(`${API}/api/sales/reports/monthly-summary`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, month, center: c.code }) })
      .then((r) => r.json()).then((d) => (d.daily_data || []).map((x) => ({ ...x, _centre: c.code, _cur: curOf ? (curOf(c.code) === "₹" ? "INR" : "AUD") : (c.country === "Australia" ? "AUD" : "INR") }))).catch(() => [])))
      .then((all) => { if (live) setRows(all.flat()); });
    return () => { live = false; };
  }, [period, selectedCenter, centers, token]);
  return rows;
}

export function SalesPeriodStrip({ period, dailyData, fmt, selectedCenter, centers, token, currency, curOf }) {
  const allRows = useAllCentreRows(period, selectedCenter, centers, token, curOf);
  const isAll = !selectedCenter || selectedCenter === "all";
  const cur = /A\$|AUD|^\$/.test(String(currency || "")) ? "AUD" : "INR";
  dailyData = isAll ? (allRows || []).filter((r) => r._cur === cur) : dailyData;
  const s = useMemo(() => {
    const today = istToday();
    const from = period === "today" ? today : new Date(Date.now() + 330 * 60000 - 6 * 86400000).toISOString().slice(0, 10);
    const rows = (dailyData || []).filter((r) => { const d = rowDate(r); return /^\d{4}-\d{2}-\d{2}$/.test(d) && d >= from && d <= today; });
    const sum = (k) => rows.reduce((a, r) => a + n(r[k]), 0);
    return { rows: new Set(rows.map(rowDate)).size, total: sum("total_sale"), cash: sum("cash_sale"), online: sum("online_sale"), bills: sum("num_bills"), guests: sum("num_guests"), exp: sum("expenses") };
  }, [period, dailyData]);
  const otherCur = isAll && (allRows || []).some((r) => r._cur !== cur);
  if (period === "month") return null;
  const tiles = [["Total Sales", fmt(s.total)], ["Cash", fmt(s.cash)], ["Online (UPI, card, aggregators)", fmt(s.online)], ["Total Bills", s.bills.toLocaleString("en-IN")], ["Total Guests", s.guests.toLocaleString("en-IN")]];
  return (
    <div className="space-y-2" data-testid="sales-period-strip">
      <p className="text-base text-[#5a3a22]">{period === "today" ? "Today" : "Last 7 days (this month's entries)"} · {s.rows} day(s) entered</p>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3">
        {tiles.map(([l, v], i) => (
          <div key={l} className="bi-tile" style={{ "--bi-fill": metalFill(i), animationDelay: `${i * 40}ms` }} data-testid={`sales-period-${i}`}>
            <span className="bi-tile-label">{l}</span><span className="bi-tile-value !text-[1.6rem]">{v}</span>
          </div>))}
      </div>
      {isAll && <p className="text-sm text-[#5a3a22]">All centres in {cur}{otherCur ? " (centres in other currencies are excluded — select the centre to see them)" : ""}.</p>}
      {isAll && !allRows && <p className="text-base">Loading centre figures…</p>}
      {!s.rows && <p className="text-base text-amber-800">No sales entered yet for this period.</p>}
    </div>
  );
}
